import { materialize } from './materializer';
import { defineFor } from './programs-infer';
import { makeTagged } from './tagged-union';
/**
 *  @since 0.0.1
 */
export function makeSummoner(cacheProgramEval, programInterpreter) {
    const summon = ((F) => materialize(cacheProgramEval(F), programInterpreter));
    const tagged = makeTagged(summon);
    const define = defineFor(undefined)();
    return {
        summon,
        tagged,
        define
    };
}
